import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "./auth/AuthContext.js";
import LoginPage from "./LoginPage.js";

/** Gate the whole admin area on auth; render the login flow until signed in. */
export default function AdminLayout() {
  const auth = useAuth();
  if (auth.status === "loading") return <div className="login-wrap"><p className="sub">Loading...</p></div>;
  if (auth.status !== "signedIn") return <LoginPage />;

  return (
    <div className="admin-shell">
      <header className="abar">
        <div className="brand"><img className="brandmark" src="/mizpah-logo.jpg" alt="Mizpah Center for Allied Health Education" /> Mizpah Admin</div>
        <nav className="anav">
          <NavLink to="/admin" end className={({ isActive }) => (isActive ? "active" : "")}>Inquiries</NavLink>
          <NavLink to="/admin/batches" className={({ isActive }) => (isActive ? "active" : "")}>Batches</NavLink>
          <NavLink to="/admin/quizzes" className={({ isActive }) => (isActive ? "active" : "")}>Quizzes</NavLink>
          <NavLink to="/admin/brochures" className={({ isActive }) => (isActive ? "active" : "")}>Brochures</NavLink>
          <NavLink to="/admin/emails" className={({ isActive }) => (isActive ? "active" : "")}>Auto-email</NavLink>
        </nav>
        <div className="aright">
          <button className="signout" onClick={auth.signOut}>Sign out</button>
        </div>
      </header>
      <main className="acontent"><Outlet /></main>
    </div>
  );
}
